import { Box, Typography } from "@mui/material";
import { FadeInContainer } from "../../Atoms";
import { useLocation } from "react-router-dom";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";
import { amber, grey } from "@mui/material/colors";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";
import { colors } from "../../../../theme/colors";
import { ProductCard } from "../../Molecules";

interface Props {
  list: Omit<ProductData, "Manufacturers" | "Versions" | "Origin">[];
  onClickAdminEdit?: (id: number) => void;
}

export function ProductList({ list, onClickAdminEdit }: Props) {
  const { BRLmoney } = useBRLmoney();
  const { pathname } = useLocation();
  const { isSmalldesktop } = useBreakpoints();

  const RenderWithLink = () => (
    <FadeInContainer>
      <Box
        display={"flex"}
        flexWrap={"wrap"}
        gap={2}
        justifyContent={isSmalldesktop ? "center" : "flex-start"}
      >
        {list?.map((item, index) => (
          <ProductCard item={item} key={index} />
        ))}
      </Box>
    </FadeInContainer>
  );

  const RenderWithoutLink = () => (
    <Box
      display={"flex"}
      flexWrap={"wrap"}
      width={"100%"}
      gap={2}
      justifyContent={isSmalldesktop ? "center" : "flex-start"}
      mt={2}
    >
      {list?.map((item, index) => (
        <Box
          key={index}
          width={151}
          display={"flex"}
          flexDirection={"column"}
          sx={{
            maxHeight: 403,
            "&: hover": { cursor: "pointer", opacity: "70%" },
          }}
          onClick={() => onClickAdminEdit(item?.id)}
        >
          {item?.isRare && (
            <Typography
              style={{
                position: "absolute",
                background: colors.red[500],
                width: 50,
                marginLeft: 105,
                marginTop: 5,
                borderRadius: 5,
                color: "#FFFFFF",
                textAlign: "center",
                transform: "rotate(45deg)",
              }}
            >
              Raro
            </Typography>
          )}
          <img
            src={item?.productsImages[0]?.code}
            style={{
              objectFit: "contain",
              width: 150,
              height: 150,
              borderRadius: 5,
              background: grey[200],
            }}
            alt={item?.name}
          />

          <Box maxWidth={150} p={1}>
            <Typography style={{ wordBreak: "break-word" }}>
              {item?.name}
            </Typography>
            <Typography
              style={{ wordBreak: "break-word", fontSize: 20 }}
              mt={1}
              color={amber[900]}
            >
              {BRLmoney(item?.price)}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
  return (
    <>
      {pathname === "/admin/products" ? (
        <RenderWithoutLink />
      ) : (
        <RenderWithLink />
      )}
    </>
  );
}
